<template>
  <div class="caseadddiv">
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '' + backSite}">{{typeName}}</el-breadcrumb-item>
      <el-breadcrumb-item>新增</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 招生招聘新增 -->
    <el-form v-if="backSite == 'backRecruit'" ref="form" label-width="80px" :model="recruitarray">
      <el-form-item label="招聘类型" :rules="[{ required: true, message: '招聘类型不能为空'}]">
        <el-input v-model="recruitarray.title"></el-input>
      </el-form-item>

      <el-form-item label="英文类型" :rules="[{ required: true, message: '招聘类型不能为空'}]">
        <el-input v-model="recruitarray.title_en"></el-input>
      </el-form-item>

      <el-form-item label="招聘内容" :rules="[{ required: true, message: '招聘内容不能为空'}]">
        <el-tag
          :key="tag"
          v-for="tag in recruitarray.menu"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
        >{{tag}}</el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        ></el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
      </el-form-item>
      <!-- 英文招聘内容 -->
      <el-form-item label="英文内容" :rules="[{ required: true, message: '招聘内容不能为空'}]">
        <el-tag
          :key="tag"
          v-for="tag in recruitarray.menu_en"
          closable
          :disable-transitions="false"
          @close="EnhandleClose(tag)"
        >{{tag}}</el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputEnVisible"
          v-model="inputEnValue"
          ref="saveEnTagInput"
          size="small"
          @keyup.enter.native="handleEnInputConfirm"
          @blur="handleEnInputConfirm"
        ></el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showEnInput">+ New Tag</el-button>
      </el-form-item>

      <el-form-item label="封面图" :rules="[{ required: true, message: '不能为空'}]">
        <el-upload
          class="upload-demo"
          action="https://api.treegroup-inc.com/admin/dashu/upload"
          accept="image/png, image/jpeg"
          :headers="headers"
          :on-success="recruitImgSuccess"
          ref="upload"
          multiple
          :limit="3"
        >
          <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件(建议上传尺寸350*210)</div>
        </el-upload>
        <div class="visibleImg">
          <img height="200px" v-show="recruitarray.image" :src="recruitarray.image" alt />
        </div>
      </el-form-item>

      <el-form-item label="权重" prop="order" :rules="[{ type: 'number', message: '权重必须为数字值'}]">
        <el-input v-model.number="recruitarray.order" type="number" size="mini"></el-input>
      </el-form-item>

      <el-form-item label="状态" :rules="[{ required: true, message: '不能为空'}]">
        <el-select v-model="recruitarray.status" placeholder="请选择发布或草稿">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="详细内容" v-show="false">
        <script id="editor" type="text/plain" style="margin-right: 20px;width:900px"></script>
      </el-form-item>
    </el-form>

    <el-form v-else-if="backSite == 'newtype'" ref="form" label-width="140px" :model="newarray">
      <el-form-item label="新闻类型" :rules="[{ required: true, message: '新闻类型不能为空'}]">
        <el-input v-model="newarray.type_name"></el-input>
      </el-form-item>

      <el-form-item label="新闻类型（英文）" :rules="[{ required: true, message: '新闻类型不能为空'}]">
        <el-input v-model="newarray.type_name_en"></el-input>
      </el-form-item>

      <el-form-item label="权重" prop="order" :rules="[{ type: 'number', message: '权重必须为数字值'}]">
        <el-input v-model.number="newarray.order" type="number" size="mini"></el-input>
      </el-form-item>
    </el-form>

    <!-- 普通新增 -->
    <el-form v-else label-width="80px" :model="dataForm">
      <el-form-item label="新闻标题" prop="title" :rules="[{ required: true, message: '新闻标题不能为空'}]">
        <el-input maxlength="29" placeholder="最多不能超过29个汉字" v-model="dataForm.title"></el-input>
      </el-form-item>

      <el-form-item label="英文标题" prop="title" :rules="[{ required: true, message: '新闻标题不能为空'}]">
        <el-input maxlength="1000" v-model="dataForm.title_en"></el-input>
      </el-form-item>

      <el-form-item label="新闻简介" prop="introduce" :rules="[{ required: true, message: '新闻简介不能为空'}]">
        <el-input placeholder="最多不能超过105个汉字" maxlength="105" v-model="dataForm.introduce"></el-input>
      </el-form-item>

      <el-form-item label="英文简介" prop="introduce" :rules="[{ required: true, message: '新闻简介不能为空'}]">
        <el-input maxlength="10005" v-model="dataForm.introduce_en"></el-input>
      </el-form-item>

      <el-form-item label="新闻时间" :rules="[{ required: true, message: '新闻时间不能为空'}]">
        <el-date-picker
          v-model="dataForm.time"
          type="date"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="权重" prop="order" :rules="[{ type: 'number', message: '权重必须为数字值'}]">
        <el-input v-model.number="dataForm.order" type="number" size="mini"></el-input>
      </el-form-item>

      <el-form-item label="状态" :rules="[{ required: true, message: '不能为空'}]">
        <el-select v-model="dataForm.status" placeholder="请选择发布或草稿">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="新闻类型" :rules="[{ required: true, message: '不能为空'}]">
        <el-select v-model="newtype.id" placeholder="请选择新闻类型">
          <el-option
            v-for="item in newtype"
            :key="item.id"
            :label="item.type_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="新闻图片" :rules="[{ required: true, message: '不能为空'}]">
        <el-upload
          class="upload-demo"
          action="https://api.treegroup-inc.com/admin/dashu/upload"
          accept="image/png, image/jpeg"
          :headers="headers"
          :show-file-list="false"
          :on-success="upImgSuccess"
          multiple
          :limit="3"
        >
          <el-button icon="el-icon-upload" style="margin-bottom:10px"></el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
        </el-upload>
        <div class="visibleImg">
          <div
            class="visibleImgdiv"
            v-for="(item,index) in dataForm.image"
            :key="index"
            @mouseover="shade(index)"
            @mouseout="unShade"
          >
            <img :src="item" alt />
            <div v-show="shadeIndex === index" class="img-shutter">
              <div @click="delImg(index)" class="ico">
                <i class="el-icon-delete" color="#fff"></i>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="新闻内容" :rules="[{ required: true, message: '不能为空'}]">
        <script id="editor" type="text/plain" style="margin-right: 20px;width:900px"></script>
      </el-form-item>

      <el-form-item label="英文内容" :rules="[{ required: true, message: '不能为空'}]">
        <script id="editor_en" type="text/plain" style="margin-right: 20px;width:900px"></script>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="subChild">确 定</el-button>
    </span>

    <Backfooter></Backfooter>
  </div>
</template>
<script>
import Backfooter from "../../components/dashu/backfooter";
import newtypeVue from "./newtype.vue";
export default {
  components: { Backfooter },
  data() {
    return {
      menu: [],
      inputVisible: false,
      inputEnVisible: false,
      inputValue: "",
      inputEnValue: "",
      shadeIndex: -1,
      headers: {
        Authorization: ""
      },
      config: {
        // serverUrl: `http://test.api.8think.com/ueditor/php/controller.php`,
        serverUrl: `https://api.treegroup-inc.com/ueditor/php/controller.php`,
        toolbars: [
          [
            "fullscreen",
            "source",
            "|",
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "formatmatch",
            "autotypeset",
            "blockquote",
            "pasteplain",
            "|",
            "forecolor",
            "backcolor",
            "insertorderedlist",
            "insertunorderedlist",
            "selectall",
            "cleardoc",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "|",
            "customstyle",
            "paragraph",
            "fontfamily",
            "fontsize",
            "|",
            "directionalityltr",
            "directionalityrtl",
            "indent",
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "|",
            "touppercase",
            "tolowercase",
            "|",
            "link",
            "unlink",
            "anchor",
            "|",
            "imagenone",
            "imageleft",
            "imageright",
            "imagecenter",
            "|",
            "insertimage",
            "emotion",
            "scrawl",
            "insertvideo",
            "music",
            "attachment",
            "map",
            "gmap",
            "insertframe",
            "insertcode",
            "webapp",
            "pagebreak",
            "template",
            "background",
            "|",
            "horizontal",
            "date",
            "time",
            "spechars",
            "snapscreen",
            "wordimage",
            "|",
            "inserttable",
            "deletetable",
            "insertparagraphbeforetable",
            "insertrow",
            "deleterow",
            "insertcol",
            "deletecol",
            "mergecells",
            "mergeright",
            "mergedown",
            "splittocells",
            "splittorows",
            "splittocols",
            "charts",
            "|",
            "print",
            "preview",
            "searchreplace",
            "drafts",
            "help"
          ]
        ]
      },
      // dataF: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      dataForm: {
        title: "",
        title_en: "",
        introduce: "",
        introduce_en: "",
        time: "",
        order: 0,
        status: 2,
        image: [], //新闻图片
        content: "",
        content_en: "",
        thumbnail: "", //封面图
        type_id: ""
      },
      // 招聘数据
      recruitarray: {
        status: 2,
        order: 0,
        title: "",
        title_en: "",
        menu: [],
        menu_en: [],
        image: ""
      },
      //新闻类型
      newarray: {
        order: 1,
        type_name: ""
      },
      img: "",
      newtype: [{ id: "", name_type: "" }],
      options: [
        {
          value: 1,
          label: "发布"
        },
        {
          value: 2,
          label: "草稿"
        }
      ],
      optionsType: [
        {
          value: 1,
          label: "招生"
        },
        {
          value: 2,
          label: "招聘"
        }
      ],
      api: "",
      backSite: "",
      typeName: ""
    };
  },
  methods: {
    // 确定
    subChild() {
      if (this.backSite === "backRecruit") {
        // 判断是否是招聘
        // console.log(this.recruitarray)
        this.recruitarray.titleEn = this.recruitarray.title_en;
        this.recruitarray.menuEn = this.recruitarray.menu_en;
        delete this.recruitarray.title_en;
        delete this.recruitarray.menu_en;
        this.$http.post(this.api, this.recruitarray).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.$router.push({ name: this.backSite });
          } else {
            this.$error({
              message: res.data.message
            });
          }
        });
      } else if (this.backSite === "newtype") {
        //判断是否为添加新闻类型
        this.$http.post(this.api, this.newarray).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.$router.push({ name: "newtype" });
          } else {
            this.$error({
              message: res.data.message
            });
          }
        });
      } else {
        this.dataForm.content = this.editor.getContent();
        this.dataForm.contentEn = this.editor_en.getContent();
        this.dataForm.type_id = this.newtype.id;
        this.dataForm.titleEn = this.dataForm.title_en;
        this.dataForm.introduceEn = this.dataForm.introduce_en;
        delete this.dataForm.title_en;
        delete this.dataForm.introduce_en;
        // delete this.dataForm.content_en;
        this.$http.post(this.api, this.dataForm).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.$router.push({ name: this.backSite });
          } else {
            this.$error({
              message: res.data.message
            });
          }
        });
      }
    },
    recruitImgSuccess(res) {
      // console.log(res)
      this.recruitarray.image =
        "https://api.treegroup-inc.com/" + res.data.url;
    },
    coverImgSuccess(res) {
      // console.log(res)
      this.dataForm.thumbnail =
        "https://api.treegroup-inc.com/" + res.data.url;
    },
    upImgSuccess(res) {
      this.dataForm.image.push(
        "https://api.treegroup-inc.com/" + res.data.url
      );
      // console.log(this.dataForm)
    },
    // pc鼠标经过显示遮罩
    shade(index) {
      this.shadeIndex = index;
    },
    // pc移出
    unShade() {
      this.shadeIndex = -1;
    },
    // 删除上传图片
    delImg(index) {
      this.dataForm.image.splice(index, 1);
    },
    handleClose(tag) {
      this.recruitarray.menu.splice(this.recruitarray.menu.indexOf(tag), 1);
    },

    EnhandleClose(tag) {
      this.recruitarray.menu_en.splice(
        this.recruitarray.menu_en.indexOf(tag),
        1
      );
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    showEnInput() {
      this.inputEnVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveEnTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.recruitarray.menu.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },

    handleEnInputConfirm() {
      let inputEnValue = this.inputEnValue;
      if (inputEnValue) {
        this.recruitarray.menu_en.push(inputEnValue);
      }
      console.log(this.recruitarray.menu_en);
      this.inputEnVisible = false;
      this.inputEnValue = "";
    }
  },
  created() {
    this.headers.Authorization = window.localStorage.getItem("user_token");
    let type = this.$route.query.type;
    switch (type) {
      case "backChildren":
        this.api = "/admin/dashu/news/create";
        this.backSite = type;
        this.typeName = "新闻中心";
        break;
      case "backPatriarch":
        this.api = "admin/parent/create";
        this.backSite = type;
        this.typeName = "家长学校";
        break;
      case "backPolitical":
        this.api = "admin/caucus/create";
        this.backSite = type;
        this.typeName = "党团之家";
        break;
      case "backInform":
        this.api = "admin/notice/park/create";
        this.backSite = type;
        this.typeName = "园区通知";
        break;
      case "backNews":
        this.api = "admin/notice/new/create";
        this.backSite = type;
        this.typeName = "新闻发布";
        break;
      case "backRecipe":
        this.api = "/admin/dashu/news/newType/create";
        this.backSite = "newtype";
        this.typeName = "新闻类型";
        break;
      case "backRecruit":
        this.api = "/admin/dashu/recruit/create";
        this.backSite = type;
        this.typeName = "招聘列表";
        break;
    }
    this.$http.post("/admin/dashu/news/newType/getList").then(res => {
      if (res.data.code === 0) {
        this.newtype = res.data.data.list;
        // console.log(res.data.data.list,this.newtype)
      } else {
        this.$error({
          message: res.data.message
        });
      }
    });
  },
  mounted() {
    UE.delEditor("editor", {});
    this.editor = window.UE.getEditor("editor", this.config);
    UE.delEditor("editor_en", {});
    this.editor_en = window.UE.getEditor("editor_en", this.config);
    this.editor.addListener("ready", res => {
      // this.editor.setContent(this.dataF);
      // console.log(this.dataF)
    });

    var ue = UE.getEditor("container");
    ue.ready(function() {
      ue.execCommand("severparam", "_token", "{{csrf_token()}}");
    });
  }
};
</script>
<style scoped>
.el-pagination {
  text-align: center;
  margin-top: 50px;
}

.visibleImg {
  display: flex;
  width: 100%;
  -ms-flex-pack: justify;
  justify-content: flex-start;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.visibleImgdiv {
  width: 20%;
  margin: 1%;
  cursor: pointer;
  background-size: cover;
  -moz-background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: relative;
}
.visibleImgdiv img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}
.img-shutter {
  width: 100%;
  height: 100%;
  float: left;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  border-radius: 10px;
  color: white;
}
.ico {
  font-size: 30px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.el-input--mini {
  width: 217px;
}
.caseadddiv {
  position: relative;
  padding-bottom: 620px;
}
</style>



// WEBPACK FOOTER //
// src/pages/backPages/caseAdd.vue